import React, { Component } from 'react';

const escapeHtmlActivity = (s) => {
    if (s == null || s === '') return '';
    return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
};

/** Texto legible para descripciones guardadas antes de metadata (o HTML crudo) */
const plainExcerptForActivity = (s, maxLen = 320) => {
    if (s == null || s === '') return '';
    let t = String(s).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    if (t.length > maxLen) t = `${t.slice(0, maxLen)}…`;
    return t;
};

const ACTION_CONFIG = {
    created: { icon: 'fas fa-plus-circle', color: '#28a745', label: 'Tarea creada' },
    state_change: { icon: 'fas fa-exchange-alt', color: '#17a2b8', label: 'Cambio de estado' },
    column_change: { icon: 'fas fa-columns', color: '#6f42c1', label: 'Cambio de columna' },
    due_date_change: { icon: 'fas fa-calendar-alt', color: '#fd7e14', label: 'Cambio de fecha' },
    name_change: { icon: 'fas fa-pencil-alt', color: '#6c757d', label: 'Cambio de nombre' },
    description_change: { icon: 'fas fa-align-left', color: '#6c757d', label: 'Cambio de descripción' },
    assigned: { icon: 'fas fa-user-check', color: '#007bff', label: 'Asignación' },
    priority_change: { icon: 'fas fa-flag', color: '#dc3545', label: 'Cambio de prioridad' },
    progress_change: { icon: 'fas fa-tasks', color: '#20c997', label: 'Cambio de progreso' },
    label_added: { icon: 'fas fa-tag', color: '#ffc107', label: 'Etiqueta agregada' },
    label_removed: { icon: 'fas fa-tag', color: '#dc3545', label: 'Etiqueta eliminada' },
    comment_added: { icon: 'fas fa-comment', color: '#17a2b8', label: 'Comentario agregado' },
    comment_updated: { icon: 'fas fa-edit', color: '#0ea5e9', label: 'Comentario editado' },
    comment_removed: { icon: 'fas fa-trash-alt', color: '#94a3b8', label: 'Comentario eliminado' },
    checklist_added: { icon: 'fas fa-check-square', color: '#28a745', label: 'Checklist agregado' },
    checklist_completed: { icon: 'fas fa-check-double', color: '#28a745', label: 'Checklist completado' },
    file_added: { icon: 'fas fa-paperclip', color: '#6c757d', label: 'Archivo agregado' },
    user_added: { icon: 'fas fa-user-plus', color: '#007bff', label: 'Usuario agregado' },
    user_removed: { icon: 'fas fa-user-minus', color: '#dc3545', label: 'Usuario eliminado' },
    notification_sent: { icon: 'fas fa-paper-plane', color: '#20c997', label: 'Notificación enviada' },
    change_request_recorded: { icon: 'fas fa-clipboard-list', color: '#6610f2', label: 'Solicitud registrada' },
    checklist_reminder_sent: { icon: 'fas fa-bell', color: '#fd7e14', label: 'Recordatorio checklist' },
    proceso_added: { icon: 'fas fa-sitemap', color: '#0d9488', label: 'Proceso vinculado' },
    proceso_removed: { icon: 'fas fa-unlink', color: '#64748b', label: 'Proceso quitado' },
};

class TaskActivityTimeline extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            activities: [],
            isLoaded: true,
            isRefreshing: false,
            showAll: false,
            filterAction: null,
        };
    }

    componentDidMount() {
        this.loadActivities();
    }

    componentDidUpdate(prevProps) {
        const prevId = prevProps.task && prevProps.task.id;
        const nextId = this.props.task && this.props.task.id;
        if (prevId && nextId && prevId !== nextId) {
            this.setState({ showAll: false, filterAction: null });
            this.loadActivities();
        }
    }

    loadActivities = () => {
        const isFirstLoad = this.state.isLoaded;
        if (!isFirstLoad) {
            this.setState({ isRefreshing: true });
        }
        fetch(`/task/get_task_activities/${this.props.task.id}`, {
            method: 'GET',
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                const list = data && data.data != null ? data.data : [];
                this.setState({
                    activities: Array.isArray(list) ? list : [],
                    isLoaded: false,
                    isRefreshing: false,
                });
            })
            .catch(() => {
                this.setState({ isLoaded: false, isRefreshing: false });
            });
    }

    /** Fecha y hora local en que ocurrió el evento (siempre visible en el historial). */
    formatAbsoluteDateTime = (dateStr) => {
        const date = new Date(dateStr);
        if (Number.isNaN(date.getTime())) return '';
        return date.toLocaleString('es-CO', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }

    /** Texto relativo solo para eventos de los últimos 7 días (complemento a la fecha absoluta). */
    formatRelativeIfRecent = (dateStr) => {
        const date = new Date(dateStr);
        if (Number.isNaN(date.getTime())) return null;
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);

        if (diffMins < 1) return 'Ahora';
        if (diffMins < 60) return `Hace ${diffMins} min`;
        if (diffHours < 24) return `Hace ${diffHours}h`;
        if (diffDays < 7) return `Hace ${diffDays}d`;
        return null;
    }

    getDescription = (activity) => {
        const userName = activity.user
            ? `${activity.user.first_name} ${activity.user.first_last_name}`
            : 'Usuario';

        switch (activity.action) {
            case 'created':
                return `<b>${userName}</b> creó esta tarea`;
            case 'state_change':
                // No mostrar códigos internos (to_do, doing, made, filed…)
                return `<b>${userName}</b> actualizó el estado de la tarea`;
            case 'column_change': {
                const oldCol = activity.metadata?.old_column_name || activity.old_value;
                const newCol = activity.metadata?.new_column_name || activity.new_value;
                return `<b>${userName}</b> movió la tarea de <b>${oldCol || '—'}</b> a <b>${newCol}</b>`;
            }
            case 'due_date_change': {
                const justification = activity.metadata?.justification;
                let msg = `<b>${userName}</b> cambió la fecha de cierre de <b>${activity.old_value || '—'}</b> a <b>${activity.new_value}</b>`;
                if (justification) {
                    msg += `<br/><span style="color:#666; font-style:italic">Justificación: ${escapeHtmlActivity(justification)}</span>`;
                }
                return msg;
            }
            case 'name_change':
                return `<b>${userName}</b> cambió el nombre de <b>${activity.old_value || '—'}</b> a <b>${activity.new_value}</b>`;
            case 'description_change': {
                const before = activity.metadata?.old_excerpt
                    ?? plainExcerptForActivity(activity.old_value);
                const after = activity.metadata?.new_excerpt
                    ?? plainExcerptForActivity(activity.new_value);
                const b = escapeHtmlActivity(before);
                const a = escapeHtmlActivity(after);
                if (!b && !a) {
                    return `<b>${userName}</b> actualizó la descripción`;
                }
                return `<b>${userName}</b> cambió la descripción de <span style="color:#555">«${b || '—'}»</span> a <span style="color:#555">«${a || '—'}»</span>`;
            }
            case 'assigned': {
                const oldUser = activity.metadata?.old_user_name;
                const newUser = activity.metadata?.new_user_name;
                const justAsgn = activity.metadata?.justification;
                let msgAsgn;
                if (oldUser) {
                    msgAsgn = `<b>${userName}</b> reasignó la tarea de <b>${oldUser}</b> a <b>${newUser}</b>`;
                } else {
                    msgAsgn = `<b>${userName}</b> asignó la tarea a <b>${newUser}</b>`;
                }
                if (justAsgn) {
                    msgAsgn += `<br/><span style="color:#666; font-style:italic">Justificación: ${escapeHtmlActivity(justAsgn)}</span>`;
                }
                return msgAsgn;
            }
            case 'priority_change':
                return `<b>${userName}</b> cambió la prioridad de <b>${activity.old_value || '—'}</b> a <b>${activity.new_value}</b>`;
            case 'progress_change':
                return `<b>${userName}</b> cambió el progreso de <b>${activity.old_value || 0}%</b> a <b>${activity.new_value}%</b>`;
            case 'label_added':
                return `<b>${userName}</b> agregó la etiqueta <b>${activity.new_value}</b>`;
            case 'label_removed':
                return `<b>${userName}</b> eliminó la etiqueta <b>${activity.old_value}</b>`;
            case 'comment_added': {
                const ex = activity.metadata?.excerpt;
                const exs = escapeHtmlActivity(ex);
                return ex
                    ? `<b>${userName}</b> agregó un comentario: <i>${exs}</i>`
                    : `<b>${userName}</b> agregó un comentario`;
            }
            case 'comment_updated': {
                const ob = activity.metadata?.old_excerpt ?? plainExcerptForActivity(activity.old_value);
                const nw = activity.metadata?.new_excerpt ?? plainExcerptForActivity(activity.new_value);
                const b = escapeHtmlActivity(ob);
                const a = escapeHtmlActivity(nw);
                return `<b>${userName}</b> editó un comentario de «${b || '—'}» a «${a || '—'}»`;
            }
            case 'comment_removed': {
                const ex = activity.metadata?.excerpt ?? plainExcerptForActivity(activity.old_value);
                const exs = escapeHtmlActivity(ex);
                return exs
                    ? `<b>${userName}</b> eliminó un comentario: «${exs}»`
                    : `<b>${userName}</b> eliminó un comentario`;
            }
            case 'checklist_added':
                return `<b>${userName}</b> agregó un checklist`;
            case 'checklist_completed': {
                const it = activity.metadata?.item;
                return it
                    ? `<b>${userName}</b> completó: <b>${it}</b>`
                    : `<b>${userName}</b> completó un ítem del checklist`;
            }
            case 'file_added': {
                const fn = activity.metadata?.file_name;
                return fn
                    ? `<b>${userName}</b> agregó el archivo <b>${fn}</b>`
                    : `<b>${userName}</b> agregó un archivo`;
            }
            case 'user_added':
                return `<b>${userName}</b> agregó al gestor <b>${activity.new_value || '—'}</b>`;
            case 'user_removed':
                return `<b>${userName}</b> quitó al gestor <b>${activity.old_value || '—'}</b>`;
            case 'notification_sent':
                return `<b>${userName}</b> envió recordatorio por correo al responsable y gestores`;
            case 'change_request_recorded': {
                const t = activity.metadata?.type_notification === 'due_date' ? 'fecha de cierre' : 'usuario responsable';
                const justCr = activity.metadata?.justification;
                let msgCr = `<b>${userName}</b> registró un cambio de ${t}`;
                if (justCr) {
                    msgCr += `<br/><span style="color:#666; font-style:italic">Justificación: ${escapeHtmlActivity(justCr)}</span>`;
                }
                return msgCr;
            }
            case 'checklist_reminder_sent': {
                const it = activity.metadata?.item;
                return it
                    ? `<b>${userName}</b> envió recordatorio por un ítem de checklist: <b>${it}</b>`
                    : `<b>${userName}</b> envió recordatorio de checklist`;
            }
            case 'proceso_added':
                return `<b>${userName}</b> vinculó el proceso <b>${activity.new_value || '—'}</b>`;
            case 'proceso_removed':
                return `<b>${userName}</b> quitó el proceso <b>${activity.old_value || '—'}</b>`;
            default:
                return `<b>${userName}</b> realizó una acción`;
        }
    }

    actionCounts = (list) => {
        return list.reduce((acc, a) => {
            const k = a.action || 'unknown';
            acc[k] = (acc[k] || 0) + 1;
            return acc;
        }, {});
    }

    filterOptionsFromActivities = (list) => {
        const seen = new Set();
        const opts = [];
        list.forEach((a) => {
            const act = a.action;
            if (!act || seen.has(act)) return;
            seen.add(act);
            const cfg = ACTION_CONFIG[act] || { label: act, color: '#6c757d' };
            opts.push({ action: act, label: cfg.label, color: cfg.color });
        });
        opts.sort((x, y) => x.label.localeCompare(y.label, 'es'));
        return opts;
    }

    render() {
        const { activities, isLoaded, isRefreshing, showAll, filterAction } = this.state;
        const counts = this.actionCounts(activities);
        const filterOptions = this.filterOptionsFromActivities(activities);
        const filtered = filterAction
            ? activities.filter((a) => a.action === filterAction)
            : activities;
        const displayActivities = showAll ? filtered : filtered.slice(0, 5);
        const hasMultipleTypes = filterOptions.length > 1;

        if (isLoaded) {
            return null;
        }

        return (
            <div className="col-md-12 mt-4">
                <div className="row">
                    <div className='col-md-1 text-center'>
                        <i className="fas fa-history" style={{ fontSize: "29px", color: '#6c757d' }}></i>
                    </div>
                    <div className='col-md-11 ui-showTask-adjunto'>
                        <div className="d-flex align-items-center flex-wrap" style={{ gap: '8px' }}>
                            <h4 style={{ fontWeight: 600, marginBottom: 0 }}>Historial de actividad</h4>
                            {isRefreshing && (
                                <small className="text-primary" style={{ fontWeight: 600 }}>
                                    <i className="fas fa-sync-alt fa-spin mr-1" /> Actualizando…
                                </small>
                            )}
                        </div>
                        <small className="text-muted">Movimientos, comentarios, gestores y notificaciones</small>
                    </div>
                </div>

                <div className="col-md-12 mb-4 mt-2">
                    <div className="row">
                        <div className='col-md-1 text-center'></div>
                        <div className='col-md-11'>
                            <div className="card" style={{
                                borderRadius: '10px',
                                border: '1px solid #e8e8e8',
                                boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                                opacity: isRefreshing ? 0.72 : 1,
                                transition: 'opacity 0.2s ease',
                            }}>
                                {activities.length > 0 && hasMultipleTypes && (
                                    <div
                                        className="task-activity-filters"
                                        style={{
                                            padding: '10px 12px',
                                            borderBottom: '1px solid #f0f0f0',
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            alignItems: 'center',
                                            gap: '8px',
                                        }}
                                    >
                                        <label
                                            htmlFor="task-activity-filter-type"
                                            style={{ fontSize: '11px', color: '#6c757d', fontWeight: 600, margin: 0 }}
                                        >
                                            Tipo:
                                        </label>
                                        <select
                                            id="task-activity-filter-type"
                                            className="form-control form-control-sm"
                                            style={{ maxWidth: '280px', width: '100%', fontSize: '13px' }}
                                            value={filterAction == null ? '' : filterAction}
                                            onChange={(e) => {
                                                const v = e.target.value;
                                                this.setState({
                                                    filterAction: v === '' ? null : v,
                                                    showAll: false,
                                                });
                                            }}
                                        >
                                            <option value="">{`Todos (${activities.length})`}</option>
                                            {filterOptions.map((opt) => (
                                                <option key={opt.action} value={opt.action}>
                                                    {`${opt.label} (${counts[opt.action] || 0})`}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                                <div className="card-body p-0">
                                    {activities.length === 0 && (
                                        <div className="text-muted text-center py-4 px-3" style={{ fontSize: '14px' }}>
                                            Aún no hay actividad registrada en esta tarea.
                                        </div>
                                    )}
                                    {activities.length > 0 && filtered.length === 0 && (
                                        <div className="text-muted text-center py-4 px-3" style={{ fontSize: '14px' }}>
                                            No hay eventos de este tipo. Elige otro filtro o «Todos».
                                        </div>
                                    )}
                                    {displayActivities.map((activity, index) => {
                                        const config = ACTION_CONFIG[activity.action] || {
                                            icon: 'fas fa-circle',
                                            color: '#6c757d',
                                            label: activity.action
                                        };
                                        const relativeWhenRecent = this.formatRelativeIfRecent(activity.created_at);

                                        return (
                                            <div
                                                key={activity.id}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    padding: '12px 16px',
                                                    borderBottom: index < displayActivities.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '50%',
                                                        backgroundColor: config.color + '15',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginRight: '12px',
                                                        flexShrink: 0,
                                                    }}
                                                >
                                                    <i
                                                        className={config.icon}
                                                        style={{ color: config.color, fontSize: '14px' }}
                                                    ></i>
                                                </div>

                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <div
                                                        style={{ fontSize: '13px', lineHeight: '1.4' }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: this.getDescription(activity)
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            fontSize: '11px',
                                                            color: '#666',
                                                            marginTop: '2px',
                                                        }}
                                                    >
                                                        <span style={{ fontWeight: 500 }}>
                                                            {this.formatAbsoluteDateTime(activity.created_at)}
                                                        </span>
                                                        {relativeWhenRecent && (
                                                            <span style={{ color: '#999' }}>
                                                                {' · '}
                                                                {relativeWhenRecent}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {filtered.length > 5 && (
                                    <div
                                        className="card-footer text-center"
                                        style={{ padding: '8px', cursor: 'pointer' }}
                                        onClick={() => this.setState({ showAll: !showAll })}
                                    >
                                        <small style={{ color: '#007bff' }}>
                                            {showAll
                                                ? 'Ver menos'
                                                : `Ver todas (${filtered.length})`
                                            }
                                        </small>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TaskActivityTimeline;
